import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function ActiveCampaignIcon(props: IconProps) {
  const id = useId();
  return (
    <Icon borderRadius="6px" fill="none" viewBox="0 0 32 32" {...props}>
      <g clipPath={`url(#active-campaign-a-${id})`}>
        <path fill="#004CFF" d="M32 0H0v32h32z" />
        <path
          fill="#004CFF"
          d="M16 27.503c6.352 0 11.503-5.15 11.503-11.503S22.353 4.497 15.999 4.497 4.496 9.647 4.496 16 9.646 27.503 16 27.503"
        />
        <path
          fill="#fff"
          d="m19.902 15.974-6.731 4.47a1.05 1.05 0 0 0-.468.884v1.117l8.16-5.354c.364-.26.598-.675.598-1.117s-.207-.858-.597-1.118l-8.16-5.301v1.04c0 .363.181.7.467.883z"
        />
        <path
          fill="#fff"
          d="M15.848 16.338c.364.233.832.233 1.195 0l.572-.39-4.262-2.885c-.26-.182-.65 0-.65.338v.857l2.21 1.482z"
        />
      </g>
      <defs>
        <clipPath id={`active-campaign-a-${id}`}>
          <rect width="32" height="32" fill="#fff" rx="4" />
        </clipPath>
      </defs>
    </Icon>
  );
}
